
import { useEffect, useState } from "react"
import DataFilter from "../../interface/resultContext/DataFilter"
import api from "../../services/api"

const useCmvProducts = (dataFilter: DataFilter) => {

  const [rows, setRows] = useState<any[]>([])
  const [loading, setloading] = useState(false)

  useEffect(() => {
    if (!dataFilter.estab) return;
    setloading(true);
    api.post('routes/cmvHistory', dataFilter)
      .then((response) => setRows(response.data))
      .catch((e) => console.error('[API/CMVHistory]:', e))
      .finally(() => setloading(false))

  }, [dataFilter])




  return { rows, loading };
}

export default useCmvProducts;